import { apiClient } from '@/lib/api-client';
import type { ApiResponse, Alert, SystemHealthDevice, ActivityFeedItem, MeterReading } from '@/types/api';

export interface RecentReading {
  readingId: number;
  deviceEui: string;
  deviceId?: string;
  serialNumber: string;
  unitNumber?: string;
  waterTotalization: number;
  computedWaterTotalization?: number;
  unitOfMeasure: string;
  computedUnitOfMeasure?: string;
  temperatureF?: number;
  rssi?: number;
  timestamp: string;
}

export interface DashboardStatsResponse {
  totalProperties: number;
  propertiesThisMonth: number;
  totalDevices: number;
  activeDevices: number;
  activeAlerts: number;
  recentAlerts: Alert[];
  recentReadings: RecentReading[];
  systemHealthDevices: SystemHealthDevice[];
  lowBatteryCount: number;
  weakSignalCount: number;
  connectionIssuesCount: number;
  activityFeed: ActivityFeedItem[];
}

export async function getDashboardStats(): Promise<ApiResponse<DashboardStatsResponse>> {
  const response = await apiClient.get<ApiResponse<DashboardStatsResponse>>('/dashboard/stats');
  return response.data;
}

export interface PropertyLocation {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  deviceCount: number;
  offlineDeviceCount: number;
  activeAlertCount: number;
}

export async function getPropertyLocations(): Promise<PropertyLocation[]> {
  const response = await apiClient.get<ApiResponse<PropertyLocation[]>>('/dashboard/property-locations');
  return response.data.data ?? [];
}

export async function getReadingById(readingId: number): Promise<MeterReading | null> {
  const response = await apiClient.get<ApiResponse<MeterReading>>(`/devices/readings/${readingId}`);
  return response.data.data ?? null;
}
